import { useState } from 'react';
import { supabase } from '@/lib/supabase';

type Change = { id: string; version: number; occurred_at: string; current_value: { title: string; success_criteria: string; status: string } };
export const ObjectiveChanges = ({ objectiveId }: { objectiveId: string }) => {
  const [changes, setChanges] = useState<Change[] | null>(null);
  const [error, setError] = useState(false);
  const load = async () => {
    if (changes) return;
    const { data, error } = await supabase.from('workspace_objective_events').select('id,version,occurred_at,current_value').eq('objective_id',objectiveId).order('version',{ascending:false}).limit(20);
    setError(Boolean(error));
    if (!error) setChanges((data ?? []) as Change[]);
  };
  return <details className="mt-4 text-sm" onToggle={event => { if (event.currentTarget.open) void load(); }}>
    <summary className="cursor-pointer text-domino-aubergine">Historique de la définition</summary>
    {error && <p role="alert" className="mt-2 text-red-700">L’historique n’a pas pu être chargé.</p>}
    {changes?.map(change => <div key={change.id} className="mt-3 border-l-2 border-domino-cardBorder pl-3"><p className="text-xs text-domino-inkSoft">Version {change.version} · {new Date(change.occurred_at).toLocaleString('fr-FR')}</p><p className="mt-1 font-medium">{change.current_value.title}</p>{change.current_value.success_criteria.trim() !== change.current_value.title.trim() && <p className="mt-1 text-domino-inkSoft">{change.current_value.success_criteria}</p>}</div>)}
    {changes?.length === 0 && <p className="mt-2 text-domino-inkSoft">Aucune modification enregistrée depuis l’activation de cet historique.</p>}
  </details>;
};
